export default "__VITE_PUBLIC_ASSET__7b2020f0__"